import { createContext } from 'react';

const UserAuthContext = createContext({
  role: '',
  setUserAuth: () => {},
});

export default UserAuthContext;
